mutation updateCompanyCommission($input: UpdateCompanyCommissionInput!) {
  updateCompanyCommission(input: $input)
}
